import { Fragment, useCallback, useState } from "react";
import { ModalPortal } from "../../components/ModalPortal";
import { CustomModal } from "../CustomModal";

const UsageContent = [
  {
    title: "Classroom Statistics",
    content: [
      {
        stats: 21,
        name: "Classes",
      },
      {
        stats: 26,
        name: "Universities",
      },
      {
        stats: 143,
        name: "Professors",
      },
    ],
    graph: true,
  },
  {
    title: "Activities Statistics",
    content: [
      {
        stats: 275,
        name: "Total Activities",
      },
      {
        stats: 5,
        name: "Original Authors",
      },
      {
        stats: 200,
        name: "Remixed Authors",
      },
    ],
    graph: true,
    divider: true,
  },
];

const bottomSection = [
  {
    title: "Share Activities on Greyled",
    content: [
      {
        stats: 275,
        name: "Private Activities",
      },
      {
        stats: 50,
        name: "Public Activities",
      },
    ],
    graph: false,
  },
];

const modalVariations = {
  published: {
    title: "Share on Greyled",
    content:
      "Greyled is about collaborating with other professors. Sharing all activities created within this book helps other OER professors and provides the best teaching experience.",
    actionBtnText: "Share all activites",
    cancelBtnText: "Go back",
  },
};

export const Usage = () => {
  const [showModal, setShowModal] = useState(false);

  const onHide = useCallback(() => {
    setShowModal(false);
  }, [showModal]);

  const removeItem = () => {};

  return (
    <>
      <ModalPortal>
        <CustomModal
          onHide={onHide}
          // loading={loading}
          showModal={showModal}
          onAction={removeItem}
          {...modalVariations["published"]}
        />
      </ModalPortal>
      <div className="d-flex flex-column gap-20 pt-2 w-70">
        {UsageContent.map((item, index) => (
          <Card {...item} key={index} />
        ))}
        {bottomSection.map((item, index) => (
          <Card {...item} key={index} setShowModal={setShowModal} />
        ))}
      </div>
    </>
  );
};

export const Card = ({
  title,
  content = [],
  graph,
  divider = false,
  setShowModal,
}) => {
  return (
    <>
      <h3 className="ft_20 text-dark-grey">{title}</h3>
      <div className="d-flex align-items-center ps-2 gap-60 mb-3">
        {content.map((item, index) => (
          <Fragment key={index}>
            <div
              className={`d-flex justify-content-between gap-4 ${
                graph ? "w-25" : "w-25"
              }`}
            >
              <div className="d-flex flex-column align-items-center gap-3 w-100">
                <h3 className="book_detail_tab_usage_content_title">
                  {item.stats}
                </h3>
                <p className="text-dark-grey ls-14 fs-14 fw-normal mb-0 text-uppercase">
                  {item.name}
                </p>
              </div>
            </div>
          </Fragment>
        ))}
        {!graph && (
          <div className="d-flex align-items-end justify-content-start w-34">
            <button
              className="book_detail_action_button book_shelft_detail_action_button_text mb-0 mt-4"
              onClick={() => setShowModal?.(true)}
            >
              Share all activites
            </button>
          </div>
        )}
        {graph && (
          <div className="bg-dark-grey graph-text-padding w-75">Graphs</div>
        )}
        {!graph && <div className="w-75"></div>}
      </div>
      {divider && <div className="divider-line w-100"></div>}
    </>
  );
};
